module.exports = __webpack_public_path__ + "img/CM-SS-25-Mazda-Lifestyle.bfd7d030.jpg";